import { useAuth } from "react-oidc-context";
import {
  OIDC_BROADCAST_UPDATE_USER,
  oidcBroadcastChannel,
  oidcTabId,
} from "./constants";

export function useJwtSilentRefresh() {
  const auth = useAuth();

  return async () => {
    const user = await auth.signinSilent();

    oidcBroadcastChannel.postMessage({
      type: OIDC_BROADCAST_UPDATE_USER,
      user,
      sender: oidcTabId,
    });
  };
}
